import mask from "@alpinejs/mask";
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, FreeMode } from "swiper/modules";
import { registerSW } from "virtual:pwa-register";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./global.js";
const updateSW = registerSW({
  onNeedRefresh() {
    console.log("onNeedRefresh");
  },
  onOfflineReady() {
    console.log("onOfflineReady");
  },
});
Alpine.plugin([mask]);
Alpine.data("initSwiper", (extra = {}) => ({
  //  init() {
  //       this.$nextTick(() => this.setup());
  //     },
  init() {
    const el = this.$el;
    if (!el || el.swiper) return;
    const swiper = new Swiper(el, {
      modules: [Navigation, FreeMode, Autoplay],
      speed: 800,
      freeMode: true,
      autoplay: false,
      slidesPerView: "auto",
      navigation: {
        nextEl: ".styles_Slider__next-button-selector__R9M5X",
        prevEl: ".styles_Slider__prev-button-selector__fsha9",
      },
      ...extra,
    });
    if (swiper.autoplay?.running) {
      el.addEventListener("mouseenter", () => swiper.autoplay.stop());
      el.addEventListener("mouseleave", () => swiper.autoplay.start());
    }
  },
}));
Alpine.data("initReadMore", () => ({
  init() {
    const el = this.$el;
    if (!el) return;
    $(el).readmore({
      collapsedHeight: 148,
      moreLink:
        '<a href="#" class="justify-center highlight absolute text-secondary-500 bottom-0 right-0 flex w-full py-3 font-semibold">ادامه مطلب</a>',
      lessLink:
        '<a href="#" class="justify-center text-secondary-500 flex w-full py-3 font-semibold">بستن</a>',
    });
  },
}));
Alpine.data("initNoUiSlider", () => ({
  init() {
    let skipSlider = document.querySelector(".styles_noUi-horizontal__dw6Te");
    let $sliderFrom = document.querySelector(
      ".TextField_TextField__input__hFMFl[name=min]",
    );
    let $sliderTo = document.querySelector(
      ".TextField_TextField__input__hFMFl[name=max]",
    );
    $sliderFrom.addEventListener("change", (e) => {
      skipSlider.noUiSlider.set([
        e.target.value.replaceAll(",", ""),
        $sliderTo.value.replaceAll(",", ""),
      ]);
    });
    $sliderTo.addEventListener("change", (e) => {
      skipSlider.noUiSlider.set([
        $sliderFrom.value.replaceAll(",", ""),
        e.target.value.replaceAll(",", ""),
      ]);
    });
    let min = parseInt($sliderFrom.dataset.range),
      max = parseInt($sliderTo.dataset.range);
    noUiSlider.create(skipSlider, {
      start: [
        $sliderFrom.value.replaceAll(",", ""),
        $sliderTo.value.replaceAll(",", ""),
      ],
      connect: true,
      direction: "rtl",
      format: wNumb({
        thousand: ",",
        decimals: 0,
      }),
      step: 1,
      range: {
        min: min,
        max: max,
      },
      pips: {
        mode: "range",
        density: 20,
      },
    });
    let skipValues = [$sliderFrom, $sliderTo];
    skipSlider.noUiSlider.on("update", function (values, handle) {
      skipValues[handle].value = values[handle];
    });
  },
  destroy(){
    $('.styles_noUi-horizontal__dw6Te').children().remove();
  }
}));
Livewire.on("clearFilter", (event) => {
  let skipSlider = document.querySelector(".styles_noUi-horizontal__dw6Te");
  let $sliderFrom = document.querySelector(
    ".TextField_TextField__input__hFMFl[name=min]",
  );
  let $sliderTo = document.querySelector(
    ".TextField_TextField__input__hFMFl[name=max]",
  );
  $sliderFrom.value = 0;
  $sliderTo.value = $sliderTo.dataset.range;
  skipSlider.noUiSlider.set([
    $sliderFrom.dataset.range,
    $sliderTo.dataset.range,
  ]);
});
const prefix = "pages.";
const isPage = (name) =>
  [
    prefix + "product-category",
    prefix + "product-offer",
    prefix + "product-tag",
    "modals.products",
  ].includes(name);
Livewire.hook("commit", ({ component, commit, respond, succeed, fail }) => {
  if (isPage(component.name)) {
    window.dispatchEvent(
      new CustomEvent("loading", {
        detail: {
          loading: true,
        },
      }),
    );
  }

  respond(() => {
    window.dispatchEvent(
      new CustomEvent("loading", {
        detail: {
          loading: false,
        },
      }),
    );
  });
});
document.addEventListener("init-component", () => {
  HAMTA.Tooltip();
});
Livewire.on("alert", (event) => {
  if ($(".modal.show").length) $(".modal.show").modal("hide");
  Swal.fire({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 4000,
    allowOutsideClick: true,
    icon: event.type,
    title: event.msg,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
});
Livewire.on("urlChanged", (event) => {
  history.pushState(null, null, event.url);
  const meta = event.meta;
  if (meta) {
    $("title").html(meta.title);
    $("meta[name=description]").attr("content", meta.description);
    $('meta[property="og:title"]').attr("content", meta.title);
    $('meta[property="og:description"]').attr("content", meta.description);
    $('meta[name="twitter:title"]').attr("content", meta.title);
    $('meta[name="twitter:description"]').attr("content", meta.description);
  }
});
Livewire.on("modal", (event) => {
  $("#" + event.target).modal(event.status || "show");
  setTimeout(() => HAMTA.Select2(), 100);
});
Livewire.on("changed", (event) => {
  if (event.plugin == "select2") setTimeout(() => HAMTA.Select2(), 100);
});
